import * as AppState from '../../../../../../store/app.state';
import * as assignmentsSubmissionsActions from '../action/assignment-submissions.actions';
import { createReducer } from '@ngrx/store';
import { on } from '@ngrx/store';

/**
 * assignment reducer used to updated store values based on certain action.
 */

/**
 * State interface extends App state State and add user state to the main state.
 */
export interface State extends AppState.State {
   assignmentSubmissions: assignmentSubmissionsState;
}

/**
 * An SubjectState interface, which represents the blueprint of the User State.
 */
export interface assignmentSubmissionsState {
   assignmentSubmissions: any;
   submissionsNumber: number;
   errorMessage: string;
}

/**
 * SubjectState initial state.
 */
export const initialState: assignmentSubmissionsState = {
   assignmentSubmissions: null,
   submissionsNumber: null,
   errorMessage: null,
};

/**
 * Subject Reducer used to update the state upon Subject actions.
 */
export const assignmentSubmissionsReducer = createReducer(
   initialState,
   /**
    * On loadSubjectsDetailsSuccess action updated current state with the following properties.
    */
   on(
      assignmentsSubmissionsActions.loadAssignmentSubmissionsStatisticsSuccess,
      (state, action): assignmentSubmissionsState => {
         return {
            ...state,
            assignmentSubmissions: action.data.data.submissions,
            submissionsNumber: action.data.data.submissionsNumber,
         };
      }
   ),

   /**
    * On loadSubjectsDetailsFailure action updated current state with the following properties.
    */
   on(
      assignmentsSubmissionsActions.loadAssignmentSubmissionsStatisticsFailure,
      (state, action): assignmentSubmissionsState => {
         return {
            ...state,
            errorMessage: action.error,
         };
      }
   )
);
